<template>
  <header>
    <el-row class="wrapper">
      <el-col :span="6" class="image-container">
        <a href="/"><img src="../../assets/logo_ssymmetry.png"></a>
      </el-col>
      <el-col :span="12" class="nav">
        <ul>
          <li v-for="(item,index) in routes" :key="index" @click="toPath(item)">
            <!-- <router-link :to="item.path">{{item.name}}</router-link> -->
            <a :class="{'router-link-exact-active' : activeName == item.name}">{{item.name}}</a>
          </li>
        </ul>
      </el-col>
      <el-col class="bts" :span="6">
        <div class="login-container" v-if="!hasLogin">
            <el-button @click="login">登录</el-button>
            <el-button @click="signUp">注册</el-button>
          </div>
        <el-dropdown v-if="hasLogin" @command="handleCommand">
            <span class="el-dropdown-link">
              个人中心
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="userInfo">
                <i class="fa fa-user info-weight"></i>用户资料
              </el-dropdown-item>
              <el-dropdown-item command="pay">
                <i class="fa fa-cny info-weight"></i>账户充值
              </el-dropdown-item>
              <!--              <el-dropdown-item command="transaction">
                              <i class="fa fa-align-justify info-weight"></i>订单管理
                            </el-dropdown-item>-->
              <el-dropdown-item command="customization">
                <i class="fa fa-book info-weight"></i>数据定制
              </el-dropdown-item>
              <el-dropdown-item command="dataAudit">
                <i class="fa fa-cog info-weight"></i>数据审计
              </el-dropdown-item>
              <el-dropdown-item command="logout">
                <i class="fa fa-sign-out info-weight"></i>注销
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
      </el-col>
    </el-row>
  </header>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import {CHANGE_USER_STATUS, SET_USER_MESSAGE, CHANGE_INDEX} from '@/store/mutation-types'
  import {logout} from '@/services/getData'
  import { clearStore } from '@/utils/localStorage'

  export default {
    mounted () {
      if (this.$cookie.get('token')) this.CHANGE_USER_STATUS(true)
      else if (this.token) this.CHANGE_USER_STATUS(true)
      else this.CHANGE_USER_STATUS(false)
    },
    data () {
      return {
        routes: [{
          path: '/', name: '首页'
        }, {
          path: '/product', name: '产品'
        }, {
          path: '/sentiment', name: '情绪因子'
        }, {
          path: '/document', name: 'API文档'
        }, {
          path: '/service', name: '客户支持'
        }, {
          path: '/recurit', name: '招聘'
        }, {
          path: '/partner', name: '合作伙伴'
        }],
        activeName: ''
      }
    },
    computed: mapState(['hasLogin', 'token', 'showNewIndex']),
    methods: {
      ...mapMutations([CHANGE_USER_STATUS, SET_USER_MESSAGE]),
      login () {
        this.$router.push('login')
      },
      signUp () {
        this.$router.push('signup')
      },
      async logOut () {
        try {
          let hasLogOut = await logout()
          if (hasLogOut) {
            this.$cookie.delete('user_id')
            this.$cookie.delete('token')
            this.CHANGE_USER_STATUS(false)
            this.SET_USER_MESSAGE({user_id: undefined, token: undefined, username: undefined})
            clearStore()
            this.$router.push({path: '/'})
          }
        } catch (error) {
          this.$cookie.delete('user_id')
          this.$cookie.delete('token')
          this.CHANGE_USER_STATUS(false)
          this.SET_USER_MESSAGE({user_id: undefined, token: undefined, username: undefined})
          clearStore()
          this.$router.push({path: '/'})
        }
      },
      handleCommand (command) {
        if (command === 'logout') this.logOut()
        else this.$router.push({path: '/' + command})
      },
      toPath(para) {
        this.activeName = para.name;
        if(para.path == '/'){
          this.CHANGE_INDEX(true);
          this.$router.push(para.path);
        } else {
          this.CHANGE_INDEX(false);
          this.$router.push(para.path);   
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/mixins';
  @import '../../styles/constants';

  header {
    width: 100%;
    height: 9rem;
    line-height: $header-height;
    margin-top: -$header-height;
    background-color: $header-color;
    // min-width: 96rem;
    z-index: 999;

    .wrapper {
      height: 100%;
      .image-container{
        height: 100%;
        font-size: 1.4rem;
        a {
          img {
            width: 17.5rem;
            height: 7rem;
            margin-left: 4rem;
            margin-top: 1rem;
          }
        }
        .beta {
          position: absolute;
          top: 1rem;
          margin-left: 1rem;
          line-height: 4rem;
          color: $primaryColor;
          font-weight: bold;
        }
      }
      .nav {
        height: 100%;
        display: flex;
        justify-content: center;
        ul {
          height: 1.6rem;
          line-height: 1.2rem;
          margin-top: 3rem;
          padding-left: 0;
          min-width: 50rem;
          li {
            list-style: none;
            float: left;
            margin-left: 1rem;
            a {
              padding: 1rem .4rem;
              text-decoration: none;
              color: #a6a6a8;
              font-size: 1.4rem;
              line-height: 1.4rem;
              &.router-link-exact-active {
                color: $active-color;
              }
            }
          }
        }
      }
    }

    .bts {
      margin-top: 2.5rem;
      line-height: 2.5rem;
      display: flex;
      align-items: center;
      button {
        @include setWh(5.2rem, 2.5rem);
        border: 0.1rem solid #a6a6a8;
        background-color: #e6e6e6;
        color: #a6a6a8;
        font-size: 1.4rem;
        cursor: pointer;
        padding: .5rem;
        a {
          color: #a6a6a8;
          text-decoration: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue